import { Sparkles, X } from "lucide-react";
import { useState } from "react";
import { toast } from "sonner";

import { api } from "@/api";
import { STATUS_LABELS, errText, euros, frDateTime } from "@/components/pipeline/utils";

const Breakdown = ({ title, rows, testid }) => (
  <div className="pl-syn-col" data-testid={testid}>
    <small>{title}</small>
    {rows.slice(0, 6).map((r) => (
      <div key={r.label} className="pl-syn-row"><span>{r.label}</span><strong>{r.n}{r.amount > 0 ? ` · ${euros(r.amount)}` : ""}</strong></div>
    ))}
    {!rows.length && <span className="pl-muted">—</span>}
  </div>
);

const Kpi = ({ label, value, testid }) => <div className="pl-syn-kpi" data-testid={testid}><strong>{value}</strong><small>{label}</small></div>;

export const PipelineSynthesis = ({ body }) => {
  const [data, setData] = useState(null);
  const [busy, setBusy] = useState(false);
  const run = async () => {
    setBusy(true);
    try { setData((await api.post("/pipeline/synthesis", body)).data); } catch (e) { toast.error(errText(e)); } finally { setBusy(false); }
  };
  if (!data) {
    return (
      <button type="button" className="pl-syn-btn" onClick={run} disabled={busy} data-testid="pipeline-synthesis-btn">
        <Sparkles size={14} />{busy ? "Synthèse en cours…" : "Générer une synthèse"}
      </button>
    );
  }
  const s = data.stats;
  return (
    <section className="pl-ai pl-syn" data-testid="pipeline-synthesis-card">
      <header>
        <span className="pl-ai-title"><Sparkles size={15} /> Synthèse des opportunités filtrées</span>
        <span className="pl-syn-actions">
          <button type="button" className="pl-link" onClick={run} disabled={busy} data-testid="pipeline-synthesis-refresh">{busy ? "Mise à jour…" : "Actualiser avec les filtres actuels"}</button>
          <button type="button" className="pl-link" onClick={() => setData(null)} aria-label="Fermer" data-testid="pipeline-synthesis-close"><X size={15} /></button>
        </span>
      </header>
      <div className="pl-syn-kpis">
        <Kpi label="opportunités" value={s.total.toLocaleString("fr-FR")} testid="syn-kpi-total" />
        <Kpi label="montant total" value={euros(s.amount) || "0 €"} testid="syn-kpi-amount" />
        <Kpi label="relances en retard" value={s.overdue.toLocaleString("fr-FR")} testid="syn-kpi-overdue" />
        <Kpi label={`sans activité (${body.dormant_days || 14} j)`} value={s.dormant.toLocaleString("fr-FR")} testid="syn-kpi-dormant" />
      </div>
      <div className="pl-syn-grid">
        <Breakdown title="PAR STATUT" rows={s.by_status.map((r) => ({ ...r, label: STATUS_LABELS[r.label] || r.label }))} testid="syn-by-status" />
        <Breakdown title="PAR ÉTAPE" rows={s.by_step} testid="syn-by-step" />
        <Breakdown title="PAR COMMERCIAL" rows={s.by_owner} testid="syn-by-owner" />
      </div>
      {data.ai ? (
        <>
          <p data-testid="syn-ai-summary">{data.ai.summary}</p>
          {data.ai.actions?.length > 0 && (
            <div className="pl-ai-next" data-testid="syn-ai-actions">
              <small>ACTIONS CONSEILLÉES</small>
              <ul>{data.ai.actions.map((a) => <li key={a}>{a}</li>)}</ul>
            </div>
          )}
        </>
      ) : <p className="pl-muted" data-testid="syn-ai-error">{data.ai_error || "Aucune opportunité à analyser."}</p>}
      <small className="pl-muted">Générée le {frDateTime(data.generated_at)}</small>
    </section>
  );
};
